import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useCart } from "../components/Cart/CartContext.jsx";
import Header from "../components/Layout/Header.jsx";
import ReviewGrid from "../components/Cart/ReviewGrid.jsx";
import CheckoutForm from "./CheckoutForm.jsx";

const stripePromise = loadStripe("pk_test_51RTlFVRfTga6P7iUGlFWK64lQi9vy4LEOHDVfFknmMRAYXCMWftKZfGzAVxRVdlfJoF82C8prC5LsZZfIiZB4Zrx00hQEiLdLZ");

export default function Checkout() {
  
  const { cart } = useCart();
  const [clientSecret, setClientSecret] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    if (cart.length === 0) {
      navigate("/");
    }
  }, [cart, navigate]);

  useEffect(() => {
    const createPaymentIntent = async () => {
      try {
        const res = await fetch("https://wildcard.introducingjeffrey.com/php/create-payment-intent.php", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ cart }),
        });

        const data = await res.json();
        if (data.clientSecret) {
          setClientSecret(data.clientSecret);
        } else {
          console.error("Stripe backend error:", data);
        }
      } catch (err) {
        console.error("Failed to create payment intent:", err);
      }
    };

    if (cart.length) createPaymentIntent();
  }, [cart]);

  const total = cart.reduce((sum, item) => sum + item.price * item.quantity, 0);
  const totalItems = cart.reduce((sum, item) => sum + item.quantity, 0);

  if (!cart.length) {
    return (
      <div className="checkout-empty">
        <h2>Your cart is empty.</h2>
      </div>
    );
  }

  return (
    <>
    <Header/>
    <div className="checkout-container">
      <h2> Review Your Order </h2>
        <ReviewGrid/>
      <hr/>
      <div>
        <h2>Secure Payment</h2>
        <h4 className="checkout-heading">
          Total Due: <strong>${total.toFixed(2)}</strong>
        </h4>

        {clientSecret && (
          <Elements stripe={stripePromise} options={{ clientSecret, appearance: { theme: "stripe" } }}>
            <CheckoutForm clientSecret={clientSecret} />
          </Elements>
        )}
      </div>
    </div>
  </>
  );
}
